'use client';
import { useEffect, useMemo, useState } from 'react';
import { useIsMarketplace } from '../../contexts/AppContext/useIsMarketplace';

export const useLoginLink = () => {
    const isMarketplace = useIsMarketplace();
    const [currentUrl, setCurrentUrl] = useState<URL>(
        new URL(process.env.NEXT_PUBLIC_MARKETPLACE_URL ?? '')
    );
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setCurrentUrl(new URL(window.location.href));
        }
    }, []);

    return useMemo(() => {
        if (isMarketplace) {
            return `/login?redirect=${encodeURIComponent(`${currentUrl.pathname}${currentUrl.search}`)}`;
        }

        const marketplaceLoginPage = `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/login`;
        return `${marketplaceLoginPage}?redirect=${encodeURIComponent(currentUrl.href)}`;
    }, [currentUrl, isMarketplace]);
};
